/**
 * Tiny toast queue — components push messages, <ToastHost/> renders them.
 */
import { create } from 'zustand';

interface Toast {
  id: number;
  message: string;
  variant: 'success' | 'error' | 'info';
}

interface ToastState {
  toasts: Toast[];
  push: (message: string, variant?: Toast['variant']) => void;
  remove: (id: number) => void;
}

let nextId = 1;
export const useToast = create<ToastState>((set) => ({
  toasts: [],
  push: (message, variant = 'success') =>
    set((state) => ({
      toasts: [...state.toasts, { id: nextId++, message, variant }],
    })),
  remove: (id) =>
    set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) })),
}));
